import React from 'react';
import { Table, Button } from 'antd';
import numeral from 'numeral';
import {setUpColumnObject, setupOverviewData} from '../../utils/utils';

export class BusinessOverviewTable extends React.Component {
  state = {
    sortedInfo: null,
  };

  handleChange = (pagination, filters, sorter) => {
    //console.log('Various parameters', pagination, filters, sorter);
    this.setState({
      sortedInfo: sorter,
    });
  }

  clearAll = () => {
    this.setState({
      sortedInfo: null,
    });
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    

    const columns = [
      setUpColumnObject('Industry', 'category', sortedInfo, true, 400),
      setUpColumnObject('Non-employing', 'Non-employing', sortedInfo, true, 200),
      setUpColumnObject('1-19 Employees', '1-19 Employees', sortedInfo, false, 200),
      setUpColumnObject('20-199 Employees', '20-199 Employees', sortedInfo, false, 200),
      setUpColumnObject('≥200 Employees', '≥200 Employees', sortedInfo, false, 200),
      setUpColumnObject('Total', 'Total', sortedInfo, false, 200),
    ];

    const dataSource = this.props.data;
    //console.log('dataSource', dataSource)

    return (
      <div className="table">
      <Table scroll={{ y: 600 }} 
      bordered={true} pagination={false}  rowKey={record => record.Group} 
      columns={columns} dataSource={dataSource} onChange={this.handleChange} />
      </div>
    );
  }
}

export default BusinessOverviewTable;



// WEBPACK FOOTER //
// ./src/components/economicProfile/BusinessOverviewTable.js